'use es6';

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { FILTER_TYPES } from '../constants/TopFilterConstants';
import { fetchPartnerTracks, fetchPublicTracks } from '../actions/TrackActions';
import { fetchPartnerLessons, fetchPublicLessons } from '../actions/LessonActions';
import { useSearchParam } from './searchParamHooks';
import getLang from 'LearningCenterUI/utils/getLang';
import { useIsPartner } from '../features/partners';
export const useFetchTracksLessonsData = (partnerOnly = false) => {
  const dispatch = useDispatch();
  const [selectedLanguage] = useSearchParam(FILTER_TYPES.LANGUAGE);
  const isPartnerPortal = useIsPartner();
  useEffect(() => {
    const fetchLanguage = selectedLanguage.length ? selectedLanguage[0].split('-')[0] : getLang();
    if (!partnerOnly) {
      dispatch(fetchPublicTracks(fetchLanguage));
      dispatch(fetchPublicLessons(fetchLanguage));
    }
    if (isPartnerPortal) {
      dispatch(fetchPartnerTracks(fetchLanguage));
      dispatch(fetchPartnerLessons(fetchLanguage));
    }
  }, [dispatch, isPartnerPortal, partnerOnly, selectedLanguage]);
};